import updateStudyStatusOnlyDoc from '../../api/study/updateStudyStatusOnlyDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useUpdateStudyStatusOnly() {
  const {fn, loading, error} = useFunctionWrap(updateStudyStatusOnlyDoc);

  return {
    updateStudyStatusOnly: fn,
    loading,
    error,
  };
}
